import { useState, useEffect } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight, MapPin, Calendar } from 'lucide-react';

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Meyrine O.",
      location: "Paris, France",
      date: "Décembre 2024",
      rating: 5,
      title: "Expérience exceptionnelle !",
      content: "Les activités se sont très bien déroulées et le guide a été au top. Nous sommes vraiment satisfaites de l'expérience que nous avons vécu ! L'organisation était parfaite et les conseils de l'équipe MVD nous ont permis de profiter pleinement de notre séjour.",
      activity: "Safari dans le désert + Burj Khalifa",
      avatar: "/images/avatars/avatar1.jpg"
    },
    {
      id: 2,
      name: "Rizlaine E.",
      location: "Lyon, France",
      date: "Novembre 2024",
      rating: 5,
      title: "Service impeccable",
      content: "J'ai booké 4 activités avec MVD et tout s'est déroulé à merveille à chaque fois donc je ne peux que les recommander ! L'équipe est très professionnelle et répond rapidement à toutes les questions. Les prix sont très compétitifs.",
      activity: "Package famille complet",
      avatar: "/images/avatars/avatar2.jpg"
    },
    {
      id: 3,
      name: "Vincent D.",
      location: "Marseille, France",
      date: "Octobre 2024",
      rating: 5,
      title: "Guide exceptionnel",
      content: "Belle journée Safari avec un guide super sympa qui a adapté sa conduite dans les dunes car il y avait 2 enfants à bord du 4x4. Aziz notre guide est un vrai photographe Instagram qui prend de superbes photos et est très volontaire. Je recommande !",
      activity: "Safari famille dans le désert",
      avatar: "/images/avatars/avatar3.jpg"
    },
    {
      id: 4,
      name: "Clémence R.",
      location: "Toulouse, France",
      date: "Septembre 2024",
      rating: 5,
      title: "Magique et inoubliable",
      content: "Magnifique magique merci à notre guide AMIN, pour son extrême gentillesse, des beaux souvenirs pour nous. L'expérience du petit-déjeuner avec les girafes était vraiment unique. Un moment que nous n'oublierons jamais !",
      activity: "Petit-déjeuner avec les girafes",
      avatar: "/images/avatars/avatar4.jpg"
    },
    {
      id: 5,
      name: "Emelyne R.",
      location: "Nantes, France",
      date: "Août 2024",
      rating: 5,
      title: "Tout était parfait",
      content: "Excellente journée, nous attendions avec impatience cette journée depuis le début de notre séjour et n'avons pas été déçus ! Tout était génial de A à Z. Notre guide était très gentil et agréable, il savait mettre à l'aise !",
      activity: "Journée découverte Dubai",
      avatar: "/images/avatars/avatar5.jpg"
    },
    {
      id: 6,
      name: "FANNY C.",
      location: "Nice, France",
      date: "Juillet 2024",
      rating: 5,
      title: "Excursion hors du commun",
      content: "Excursion hors du temps et hors du commun. C'était très beau. Passage de la frontière ultra rapide. Guide francophone sympathique et connaissant bien son sujet. Repas excellent à bord. Avons vu des dauphins à profusion.",
      activity: "Croisière Musandam Oman",
      avatar: "/images/avatars/avatar6.jpg"
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(nextTestimonial, 6000);
    return () => clearInterval(timer);
  }, []);

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Nos Clients <span className="text-amber-600">Témoignent</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Plus de 100 000 voyageurs nous ont fait confiance. 
            Découvrez leurs expériences authentiques et leurs moments inoubliables à Dubaï.
          </p>
          
          {/* Stats */}
          <div className="flex justify-center items-center space-x-8 mb-8">
            <div className="text-center">
              <div className="flex items-center justify-center space-x-1 mb-2">
                <Star className="text-amber-400 fill-current" size={20} />
                <span className="text-2xl font-bold text-gray-900">4.9</span>
              </div>
              <p className="text-gray-600 text-sm">Note moyenne</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-900 mb-2">2,847</div>
              <p className="text-gray-600 text-sm">Avis vérifiés</p>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-900 mb-2">98%</div>
              <p className="text-gray-600 text-sm">Clients satisfaits</p>
            </div>
          </div>
        </div>

        {/* Main testimonial */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 relative">
            {/* Quote icon */}
            <div className="absolute top-6 left-6 w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
              <Quote size={24} className="text-amber-600" />
            </div>

            {/* Navigation buttons */}
            <button
              onClick={prevTestimonial}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 transition-colors z-10"
            >
              <ChevronLeft size={20} />
            </button>
            
            <button
              onClick={nextTestimonial}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 transition-colors z-10"
            >
              <ChevronRight size={20} />
            </button>

            <div className="pt-8">
              {/* Rating */}
              <div className="flex items-center justify-center space-x-1 mb-6">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-amber-400 fill-current" size={24} />
                ))}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 text-center mb-6">
                {currentTestimonial.title}
              </h3>

              {/* Content */}
              <blockquote className="text-lg text-gray-700 text-center leading-relaxed mb-8 max-w-3xl mx-auto">
                "{currentTestimonial.content}"
              </blockquote>

              {/* Author info */}
              <div className="flex items-center justify-center space-x-4">
                <img
                  src={currentTestimonial.avatar}
                  alt={currentTestimonial.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div className="text-center">
                  <div className="font-semibold text-gray-900 text-lg">
                    {currentTestimonial.name}
                  </div>
                  <div className="flex items-center justify-center space-x-4 text-gray-600 text-sm">
                    <div className="flex items-center space-x-1">
                      <MapPin size={14} />
                      <span>{currentTestimonial.location}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Calendar size={14} />
                      <span>{currentTestimonial.date}</span>
                    </div>
                  </div>
                  <div className="text-amber-600 text-sm font-medium mt-1">
                    {currentTestimonial.activity}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Indicators */}
          <div className="flex justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'bg-amber-600 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Additional testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <div key={testimonial.id} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-amber-400 fill-current" size={16} />
                ))}
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">{testimonial.title}</h4>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                "{testimonial.content.substring(0, 120)}..."
              </p>
              <div className="flex items-center space-x-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="font-medium text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-gray-500 text-xs">{testimonial.activity}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://maps.app.goo.gl/PeKjvgxzUoUdGiXe8?g_st=iw"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-amber-600 hover:bg-amber-700 text-white px-8 py-3 rounded-lg font-medium transition-colors"
          >
            <Star size={20} />
            <span>Laissez votre avis</span>
          </a>
        </div>
      </div>
    </section>
  );
}